"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons/");

exports.Tag = utils_2.forwardRef(function Tag(props, ref) {
  var label = props.label,
      status = props.status,
      size = props.size,
      onClose = props.onClose;

  var _status = status || 'normal';

  var tagIcon = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tmargin-right: 0.25em;\n\t"], ["\n\t\tmargin-right: 0.25em;\n\t"])));
  var tagClose = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tbackground-color: rgba(255, 255, 255, 0.3);\n\t\tborder: solid 1px rgba(0, 0, 0, 0.02);\n\t\tdisplay: flex;\n\t\tmargin-left: 0.5em;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 1.8em;\n\t\twidth: 1.8em;\n\t\theight: 1.8em;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease-in-out;\n\t\t&:hover {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.02);\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"], ["\n\t\tbackground-color: rgba(255, 255, 255, 0.3);\n\t\tborder: solid 1px rgba(0, 0, 0, 0.02);\n\t\tdisplay: flex;\n\t\tmargin-left: 0.5em;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 1.8em;\n\t\twidth: 1.8em;\n\t\theight: 1.8em;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease-in-out;\n\t\t&:hover {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.02);\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"])));
  var tagContainer = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tmin-height: 1.438em;\n\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: ", ";\n\t\tpadding: ", ";\n\t\t--tag-background-active: ", ";\n\t\t--tag-background-info: ", ";\n\t\t--tag-background-warning: ", ";\n\t\t--tag-background-error: ", ";\n\n\t\tbackground: var(--tag-background-", ");\n\n\t\t--tag-color-active: ", ";\n\t\t--tag-color-info: ", ";\n\t\t--tag-color-warning: ", ";\n\t\t--tag-color-error: ", ";\n\n\t\tcolor: var(--tag-color-", ");\n\n\t\t", ";\n\t\tborder-radius: 10px;\n\n\t\tmax-width: max-content;\n\t\ttext-overflow: ellipsis;\n\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 0.75em;\n\t\tline-height: 0.938em;\n\t"], ["\n\t\tmin-height: 1.438em;\n\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: ", ";\n\t\tpadding: ", ";\n\t\t--tag-background-active: ", ";\n\t\t--tag-background-info: ", ";\n\t\t--tag-background-warning: ", ";\n\t\t--tag-background-error: ", ";\n\n\t\tbackground: var(--tag-background-", ");\n\n\t\t--tag-color-active: ", ";\n\t\t--tag-color-info: ", ";\n\t\t--tag-color-warning: ", ";\n\t\t--tag-color-error: ", ";\n\n\t\tcolor: var(--tag-color-", ");\n\n\t\t", ";\n\t\tborder-radius: 10px;\n\n\t\tmax-width: max-content;\n\t\ttext-overflow: ellipsis;\n\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 0.75em;\n\t\tline-height: 0.938em;\n\t"])), !label ? 'center' : 'flex-start', onClose ? '0.2em 0.2em 0.2em 0.5em' : !label ? '0.5em 0.35em 0.5em 0.5em' : '0.5em', foundation_1.colors.status.success10, foundation_1.colors.status.info10, foundation_1.colors.status.warning10, foundation_1.colors.status.error10, _status, foundation_1.colors.primary.green, foundation_1.colors.status.info, foundation_1.colors.status.warning, foundation_1.colors.status.error, _status, !status && 'border: solid 1px rgba(0,0,0,.1);');
  var iconTemp = null;

  if (status) {
    switch (_status) {
      case 'normal':
        break;

      case 'active':
        iconTemp = 'check';
        break;

      case 'info':
        iconTemp = 'info-circle';
        break;

      case 'warning':
        iconTemp = 'exclamation-triangle';
        break;

      case 'error':
        iconTemp = 'times';
        break;

      default:
        break;
    }
  }

  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tagContainer
  }, iconTemp && (0, _core.jsx)("div", {
    css: tagIcon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: iconTemp
  })), label, onClose && (0, _core.jsx)(lseds_1.lseds.div, {
    css: tagClose,
    onClick: onClose
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faTimes
  })));
});

if (utils_1.isDev) {
  exports.Tag.displayName = 'Tag';
}

var templateObject_1, templateObject_2, templateObject_3;